var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityRates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 631.478,
    height: 534.98,
    viewBox: "0 0 631.478 534.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c6dc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M114.611,167.305V365.82H49V167.305L81.805,134.5Z",
    transform: "translate(33.434 91.773)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M235.611,129.058V398.23H170V108.87L193.553,87Z",
    transform: "translate(115.995 59.362)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M175.111,122.5V374.008H109.5V187.27Z",
    transform: "translate(74.715 83.585)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M296.611,199.27V364.138H231V134.5Z",
    transform: "translate(157.617 91.773)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M631.478,16.218,620.425,57.485,593.76,156.961l-36.406-36.406-76.108,76.092L451.52,226.374l-29.743-29.727L309.363,84.234,202.838,190.759l-29.744,29.727-29.744-29.727L116.77,164.178,42.058,238.89V492.922H513.951a21.029,21.029,0,1,1,0,42.058H0V21.029a21.029,21.029,0,1,1,42.058,0V179.42l74.712-74.712,29.744,29.727,26.581,26.581L279.619,54.491l29.744-29.744,29.744,29.744L451.52,166.9l76.092-76.092L490.735,53.935l100.755-27,39.989-10.716Z",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityRates);
export default __webpack_public_path__ + "static/media/productivityRates.58b290d4b17ba118f5330b132b605060.svg";
export { ForwardRef as ReactComponent };